import { render, staticRenderFns } from "./OccupancyBlockOverlay.vue?vue&type=template&id=024ef8ee&scoped=true"
import script from "./OccupancyBlockOverlay.vue?vue&type=script&lang=js"
export * from "./OccupancyBlockOverlay.vue?vue&type=script&lang=js"
import style0 from "./OccupancyBlockOverlay.vue?vue&type=style&index=0&id=024ef8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ef8ee",
  null
  
)

export default component.exports